export default __webpack_public_path__ + "static/media/naowalk.52177d4b.gif";